import { USStateOrTerritory } from "@inrev/common";
import { FC } from "react";
import { Checkbox } from "./Checkbox";

export type StatePickerProps = {
	value: { [K in USStateOrTerritory]: string[] };
	onChange: (state: string, checked: boolean) => void;
};

export const StatePicker: FC<StatePickerProps> = ({ value, onChange }) => {
	return (
		<div data-testid="state-picker" className="flex flex-col">
			<div className="grid grid-cols-9 gap-2 flex-wrap">
				{Object.entries(value).map(([state, productTypeArr]) => (
					<div
						data-testid="state-checkbox"
						key={state}
						className="flex flex-row items-center gap-1 col-span-1"
					>
						<Checkbox
							checked={productTypeArr.length > 0}
							onChange={(checked) => onChange(state, checked)}
						/>
						<span className="text-sm">{state}</span>
					</div>
				))}
			</div>
		</div>
	);
};
